module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/5cbe857a07cdefccea566089e71a7053.png";